<template>
    <div class="lc_calendar">

        <div class="TQ_text_32px TQ_grid_col_Auto1frAuto TQ_margin_bottom_4px"
             :style="{'direction' : helper_getDirectionByLangCode_fe(p_system_langCode_s)}">
            <img class="TQ_width_28px TQ_clickable TQ_grid_verticalCenter"
                 :class="{'TQ_rotated180deg' : helper_getDirectionByLangCode_fe(p_system_langCode_s) === enum_directions.rtl}"
                 @click="m_preMonth_f" :src="ass_img_leftArrow">
            <div class="TQ_grid_verticalCenter"> {{monthNames[currentMonth][p_system_langCode_s]}} {{currentYear}} </div>
            <img class="TQ_width_28px TQ_clickable TQ_grid_verticalCenter"
                 :class="{'TQ_rotated180deg' : helper_getDirectionByLangCode_fe(p_system_langCode_s) === enum_directions.rtl}"
                 @click="m_nextMonth_f" :src="ass_img_rightArrow">
        </div>


        <div class="lc_body">

            <!-- title -->
            <div class="lc_dayContainer" v-for="day in optionsDays">
                <div class="lc_dayTitle TQ_text_bold TQ_bg_purple_dark TQ_textColor_white">
                    {{day[p_system_langCode_s]}}
                </div>
            </div>

            <!-- days -->
            <div class="lc_dayContainer" v-for="day in month">


                <div class="lc_day "
                     :class="{'TQ_bg_purple_lite2': m_today_b(day), 'TQ_bg_gray3' : !m_currentMonth_b(day), 'TQ_clickable' : m_currentMonth_b(day)}"
                     @click="m_currentMonth_b(day) && m_clickDay_f(day)"
                     @mouseleave="hoverCellTime_t=null"
                     @mouseover="hoverCellTime_t = day.getTime()">
                    {{day.getDate()}}

                    <div>
                        <div class="TQ_padding_4px TQ_bg_purple TQ_align_initial" v-if="m_showAddNewEvent_fb(day)">
                            <img class="TQ_width_20px TQ_verticalAlignMiddle" :src="ass_img_add_w"/>
                            <div class="TQ_padding_4px TQ_inline"></div>
                            <div class="TQ_inline TQ_verticalAlignMiddle">
                                {{ass_strings.twoWords_newEvent[p_system_langCode_s]}}
                            </div>
                        </div>

                        <div @mouseover.stop="hoverCellTime_t = null"
                             v-if="p_events_byDayTime_a[day.getTime()] && m_currentMonth_b(day)">

                            <div class="lc_event TQ_borderRadius TQ_box_shadow"
                                 v-for="event in p_events_byDayTime_a[day.getTime()]"
                                 :style="{backgroundColor: event.backgroundColor, color: event.color}"
                                 @click.stop="event.clickCallback(event)">
                                <div class="TQ_text_14px">{{event.title}}</div>
                                <div class="lc_hour TQ_direction_ltr TQ_text_12px ">{{format_date_hh_mm_fs(event.startingDate)}} </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {format_date_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {date_newDate_fd, date_sameDay_fb} from "../../scripts/S_Date";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {ass_img_add_w, ass_img_arrow_left_b, ass_img_arrow_right_b} from "../../assets/scripts/Ass_Files";
    import {helper_getDirectionByLangCode_fe} from "../../scripts/S_Helper";
    import {enum_directions} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "TqCalendarBig",
        props:{
            p_events_byDayTime_a:{
                type:Object,
                default: () => { return {} }
            },
            p_system_langCode_s:{
                require:true,
                type: String
            },
            p_showCreateNewEvent_b:{
                type: Boolean,
                default: false
            },


            pe_onClickDay_f: {
                type: Function,
                default(){return () => {}}
            },
            pe_onChangeMonth_f: {
                type: Function,
                default(){return () => {}}
            },
        },

        data(){
            return{
                currentYear: null,
                currentMonth: null,
                selectedDay: null,
                month :[],
                date: date_newDate_fd(),
                hoverCellTime_t : null,

                // imports
                format_date_hh_mm_fs: format_date_hh_mm_fs,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
                enum_directions : enum_directions,
                ass_img_leftArrow : ass_img_arrow_left_b,
                ass_img_rightArrow : ass_img_arrow_right_b,
                ass_img_add_w : ass_img_add_w,
                ass_strings : ass_strings,
                optionsDays : [ass_strings.oneWord_Sun, ass_strings.oneWord_Mon, ass_strings.oneWord_Tue,ass_strings.oneWord_Wed,ass_strings.oneWord_Thu,ass_strings.oneWord_Fri, ass_strings.oneWord_Sat],
                monthNames  : [
                    ass_strings.oneWord_January, ass_strings.oneWord_February, ass_strings.oneWord_March, ass_strings.oneWord_April, ass_strings.oneWord_May,
                    ass_strings.oneWord_June, ass_strings.oneWord_July, ass_strings.oneWord_August, ass_strings.oneWord_September, ass_strings.oneWord_October,
                    ass_strings.oneWord_November, ass_strings.oneWord_December,
                ],
            }
        },

        methods:{

            // user events
            m_nextMonth_f(){
                let currentDisplayMonth_d = new Date(this.currentYear,this.currentMonth +1, 1)
                this.m_setMouth_f(currentDisplayMonth_d)

                this.pe_onChangeMonth_f(currentDisplayMonth_d)
            },
            m_preMonth_f(){
                let currentDisplayMonth_d = new Date(this.currentYear,this.currentMonth -1, 1)
                this.m_setMouth_f(currentDisplayMonth_d)

                this.pe_onChangeMonth_f(currentDisplayMonth_d)
            },
            m_clickDay_f(day_d){

                if(!this.m_showAddNewEvent_fb(day_d)){
                    return
                }

                this.pe_onClickDay_f(day_d)
            },

            m_showAddNewEvent_fb(day){

                if(!this.p_showCreateNewEvent_b ||  this.currentMonth !== day.getMonth()){
                    return
                }


                let now_d = date_newDate_fd()
                now_d.setMonth(now_d.getMonth() - 1)

                // mouth to the past
                if(day.getTime() < now_d.getTime() ){
                    return false
                }

                // two mouths to the future
                now_d.setMonth(now_d.getMonth() + 3)
                if(day.getTime() > now_d.getTime()){
                    return false
                }

                return this.hoverCellTime_t === day.getTime()
            },

            // dom
            m_setMouth_f(newDate){
                this.month = []
                this.currentMonth = newDate.getMonth()
                this.currentYear = newDate.getFullYear()

                let temp = new Date(this.currentYear,this.currentMonth, 1 - newDate.getDay());

                // add preMonth days
                while(temp.getMonth() !==  this.currentMonth){

                    this.month.push(temp)
                    temp = date_newDate_fd(temp.getTime())
                    temp.setDate(temp.getDate() + 1);
                }

                // add thisMonth days
                while(temp.getMonth() ===  this.currentMonth){
                    this.month.push(temp)
                    temp = date_newDate_fd(temp.getTime())
                    temp.setDate(temp.getDate() + 1);
                }

                // add nextMonth days
                while(temp.getDay() !== 0){
                    this.month.push(temp)
                    temp = date_newDate_fd(temp.getTime())
                    temp.setDate(temp.getDate() + 1);
                }
            },
            m_today_b(day_d){
                let now = date_newDate_fd()
                return date_sameDay_fb(day_d, now)
            },
            m_currentMonth_b(day_d){
                return this.currentMonth === day_d.getMonth()
            },

        },

        created(){
            let now = date_newDate_fd()
            now.setDate(1)
            this.m_setMouth_f(now)
        },

    }
</script>

<style scoped lang="scss">

    .lc_calendar{
        overflow: auto;

        .lc_body{
            min-width: 600px;

            .lc_dayContainer{
                width:calc(100% / 7);
                display:inline-block;
                color: gray;

                .lc_dayTitle{
                    height: 20px;
                    padding:4px;
                    border: 1px solid #000;
                    display: grid;
                }

                .lc_day{
                    height: 130px;
                    padding:4px;
                    border: 1px solid #000;
                    text-align: left;
                    display: grid;
                    overflow-y: auto;


                    .lc_event{
                        padding: 4px;
                        cursor: pointer;
                        margin: 2px 0px;

                        &:hover{
                            /*border: 1px solid var(--color-gold);*/
                            /*color: var(--color-gold)!important;*/
                            box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);

                        }
                    }




                }
            }

        }

        .lc_hour{
            text-align: right;
        }
    }

</style>
